import React from 'react'
import PropTypes from 'prop-types'
import { Button, Typography } from '@chilecompra/react-kit/components'
import { DialogCustom, GridContainer, GridItem, Image, ImageContainer, Strong } from './InfoDataDialog.styles'

const InfoEMTDialog = props => {
  const { open, onClose } = props

  return (
    <DialogCustom open={open} onClose={onClose}>
      <GridContainer>
        <ImageContainer>
          <Image alt="Imagen ayuda" src="/assets/images/infoDialogEMT.svg" />
        </ImageContainer>
        <GridItem xs={12}>
          <Typography align="left" color="black1" fontSize="16px" lineHeight="24px" weight="400" variant="body2">
            En Mercado Público, las empresas de menor tamaño que pueden participar incluyen micro, pequeñas y medianas
            empresas (MiPyMEs). Estas empresas son fundamentales para el sistema de compras públicas en Chile y se
            clasifican de la siguiente manera:
            <br />
            {'\u00A0'} <Strong> 1. Microempresas:</Strong> Aquellas con ingresos anuales hasta 2.400 UF.
            <br />
            {'\u00A0'}
            <Strong> 2. Pequeñas empresas:</Strong> Con ingresos anuales entre 2.400 y 25.000 UF.
            <br />
            {'\u00A0'}
            <Strong> 3. Medianas empresas:</Strong> Con ingresos anuales entre 25.000 y 100.000 UF.
            <br />
            <br />
            El sistema de Mercado Público está diseñado para facilitar la participación de estas empresas, promoviendo
            la transparencia y la competencia. Además,{' '}
            <Strong>
              iniciativas como Compra Ágil están específicamente orientadas a aumentar las oportunidades para las
              empresas de menor tamaño
            </Strong>
            , permitiéndoles acceder a negocios de hasta 100 UTM.
            <br />
            <br />
            Estas empresas juegan un rol crucial en la economía chilena, no solo por su participación en el mercado de
            compras públicas, sino también por su contribución a la generación de empleo y el desarrollo económico
            local.
          </Typography>
        </GridItem>
      </GridContainer>
      <GridContainer margin="32px 0 24px">
        <GridItem align="center" xs={12}>
          <Button color="primary" type="button" onClick={onClose}>
            Cerrar
          </Button>
        </GridItem>
      </GridContainer>
    </DialogCustom>
  )
}

InfoEMTDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
}

export default InfoEMTDialog
